import { useState } from "react";
import type { ButtonProps } from "@circle-react-shared/uikit/Button";
import { Button } from "@circle-react-uikit/Button";
import { RECURRING_EDIT_MODE } from "../../utils";
import { EditRecurringModal } from "../EditRecurringModal";

type RecurringEditMode =
  (typeof RECURRING_EDIT_MODE)[keyof typeof RECURRING_EDIT_MODE];

interface SubmitEditButtonProps extends Omit<ButtonProps, "onClick"> {
  children: React.ReactNode;
  isPublishing?: boolean;
  isRecurringEvent?: boolean;
  isStartsAtDirty?: boolean;
  onEditModeConfirm: (editMode: RecurringEditMode) => void;
  shouldHideAllEventOption?: boolean;
  type?: "button" | "submit" | "reset";
}

export const SubmitEditButton = ({
  onEditModeConfirm,
  isRecurringEvent = false,
  isPublishing = false,
  children,
  isStartsAtDirty = false,
  shouldHideAllEventOption = false,
  type = "button",
  ...passthroughProps
}: SubmitEditButtonProps) => {
  const [isRecurringModalOpen, setIsRecurringModalOpen] = useState(false);

  const onClickHandler = () => {
    if (isRecurringEvent) {
      setIsRecurringModalOpen(true);
    } else {
      onEditModeConfirm(RECURRING_EDIT_MODE.CURRENT);
    }
  };

  const onConfirmHandler = (editMode: RecurringEditMode) => {
    setIsRecurringModalOpen(false);
    onEditModeConfirm(editMode);
  };

  return (
    <>
      <Button type={type} onClick={onClickHandler} {...passthroughProps}>
        {children}
      </Button>
      <EditRecurringModal
        show={isRecurringModalOpen}
        onConfirm={onConfirmHandler}
        onCloseModal={() => setIsRecurringModalOpen(false)}
        isPublishing={isPublishing}
        showCurrentOptionOnly={isStartsAtDirty}
        shouldHideAllEventOption={shouldHideAllEventOption}
      />
    </>
  );
};
